const isArray = (input: unknown): input is unknown[] => Array.isArray(input);

export default isArray;
